import { render } from "./uploadResume.vue?vue&type=template&id=fc1c8d0a"
import script from "./uploadResume.vue?vue&type=script&lang=js"
export * from "./uploadResume.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__